export class ListPermissionsResponse {
    'permissions';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "permissions",
            "baseName": "permissions",
            "type": "Array<Permission>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListPermissionsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
